import { Version, VersionTuple } from '@builder/schemas';

export const joinVersion = (versionTuple: VersionTuple): Version => {
  return versionTuple.join('.');
};
